/** @jsx jsx */
import { jsx } from '@emotion/react';

import useRouter from 'js/lib/useRouter';

import { Accordion, AccordionGroup, AccordionHeader, AccordionPanel, Grid, Typography2 } from '@coursera/cds-core';

import getFAQs from 'bundles/enterprise-admin-skills/constants/FAQs';
import { Heading, Spacer } from 'bundles/enterprise-ui/components';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/enterprise-admin-skills';

export const FAQCollapse = ({ defaultExpanded }: { defaultExpanded?: number[] }) => (
  <AccordionGroup defaultExpanded={defaultExpanded}>
    {getFAQs().map(({ id, title, paragraphs, infoGraph }) => (
      <Accordion key={id} id={id} data-testid="FAQ">
        <AccordionHeader label={title} />
        <AccordionPanel css={{ padding: 24 }}>
          <Grid container spacing={24}>
            <Grid item xs={12} md={6}>
              {paragraphs.map((text, index) => (
                <Typography2 component="p" key={index} variant="bodyPrimary" css={{ marginBottom: 16 }}>
                  {text}
                </Typography2>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              {infoGraph}
            </Grid>
          </Grid>
        </AccordionPanel>
      </Accordion>
    ))}
  </AccordionGroup>
);

const TSPFAQ = () => {
  const router = useRouter();
  const hash = router.location.hash?.slice(1);
  const defaultExpanded = hash ? [getFAQs().findIndex((_) => _.id === hash)] : [];
  return (
    <TrackedDiv
      trackingName="tsp_faq"
      withVisibilityTracking={true}
      requireFullyVisible={false}
      trackClicks={false}
      css={{
        marginTop: 25,
        paddingTop: 48,
        paddingBottom: 60,
      }}
    >
      <Heading as="h2">{_t('FAQ about SkillSets')}</Heading>
      <Spacer size={32} />
      <FAQCollapse defaultExpanded={defaultExpanded} />
    </TrackedDiv>
  );
};

export default TSPFAQ;
